import { fromClassArray } from "fw-model";

export class PlatformStatusInfo {
    Name: string;
    Description: string;
    Healthy: boolean;
    Data: { [key: string]: string } = {};
    DataTypes: string[] = [];
    Bulletins: string[] = [];
}

export class PlatformStatusCategory {
    Name: string;
    Group: string;
    @fromClassArray(PlatformStatusInfo) Resources: PlatformStatusInfo[];
}

export class PlatformStatus {
    @fromClassArray(PlatformStatusCategory) Categories: PlatformStatusCategory[];
}

export class PlatformBackupInfo {
    Id: string;
    Status: string;
    StartTimeUtc: string;
    EndTimeUtc: string;
}

export class PlatformBackupHistory {
    Name: string;
    @fromClassArray(PlatformBackupInfo) Backups: PlatformBackupInfo[];
}

export class PlatformBackupStatus {
    @fromClassArray(PlatformBackupHistory) Histories: PlatformBackupHistory[];
}

export class PlatformMetricsCharts {
    Base64: string;
}

export class PlatformElasticsearchIndexInfo {
    Index: string;
    Health: string;
    Status: string;
    TotalDocuments: number;
    TotalDeleted: number;
    TotalStorageSize: number;
    PrimaryShardCount: number;
    ReplicaCount: number;
}

export class PlatformElasticsearchInfo {
    Status: string;
    NumberOfNodes: number;
    @fromClassArray(PlatformElasticsearchIndexInfo) Indices: PlatformElasticsearchIndexInfo[];
}
